import { useState } from "react";
import { Flex } from "@unifize/sarah";

type Props = {
  value: string;
  maxLines?: number;
  color?: string;
};

const TruncatedText = ({
  value = "",
  maxLines = 2,
  color = "white",
}: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Flex style={{ marginTop: "0.5rem" }}>
      <span
        style={{
          display: "-webkit-box",
          fontWeight: 100,
          WebkitLineClamp: isExpanded ? "unset" : maxLines,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          lineHeight: "14px",
          fontSize: "12px",
          wordBreak: "break-all",
          color,
        }}
      >
        {isExpanded ? value : value.slice(0, 87).concat("...")}
      </span>
      {value.length > 87 && (
        <span
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            position: "absolute",
            color: "white",
            fontSize: "12px",
            right: "0.7rem",
            bottom: "0.45rem",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          {isExpanded ? "See less" : "See more"}
        </span>
      )}
    </Flex>
  );
};

export default TruncatedText;
